<template>
  <v-dialog v-model="internalValue" max-width="600px">
    <v-card color="#f9efd5" class="pa-4" style="position: relative;">
      <v-layout row wrap align-center justify-space-between>
        <!-- LEFT: Text -->
        <v-flex xs12 sm8>
          <p class="text font-weight-bold mb-1">
            {{ $t("params.ask_estimated_players") }}
          </p>
          <span
            class="message_error grey--text text--darken-1"
            v-html="$t(errorKey, { s: estimateMinimum })"
          ></span>
        </v-flex>

        <!-- RIGHT: Input and Button -->
        <v-flex xs12 sm4>
          <v-layout row wrap align-center justify-end>
            <v-flex xs6>
              <v-text-field
                v-model="inputEstimate"
                type="number"
                min="1"
                solo
                hide-details
                :error="error"
                :class="['mr-2', { error: error }]"
              />
            </v-flex>
            <v-flex xs6>
              <v-btn
                color="orange darken-1"
                dark
                block
                @click="submit"
              >
                {{ $t("update") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EstimationDialog',
  props: {
    error: { type: Boolean, default: false },
    errorKey: { type: String, default: 'errors.estimate_players' },
    value: { type: Boolean, required: true },
    estimate: { type: Number, default: null },
    estimateMinimum: { type: Number, default: 0 }
  },
  data () {
    return {
      inputEstimate: this.estimate
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    submit () {
      const val = parseInt(this.inputEstimate)
      if (isNaN(val) || val < this.estimateMinimum) {
        this.$emit('error', true)
        return
      }
      this.$emit('error', false)
      this.$emit('update', val)
      this.internalValue = false
    },
    close () {
      this.internalValue = false
    }
  },
  watch: {
    estimate (newVal) {
      this.inputEstimate = newVal
    }
  }
}
</script>

<style scoped>
.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
</style>
